import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/carPackage';
import PackagesCarouselSkeleton from '../../others/Skeleton/SkeletonPackagesCarousel';
import FaresCarouselBackgroundImageContainerMobile from '../FaresCarouselBackgroundImageContainerMobile';

const FlightsCarsPackagesGridContainerMobile = (props) => (
  <FaresCarouselBackgroundImageContainerMobile
    SkeletonInstance={PackagesCarouselSkeleton}
    {...props}
    getFares={getFares}
  />
);

FlightsCarsPackagesGridContainerMobile.componentName = 'FlightsCarsPackagesGridContainerMobile';

FlightsCarsPackagesGridContainerMobile.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

FlightsCarsPackagesGridContainerMobile.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'flightsCarsPackagesGridContainer'
  }
};

export default FlightsCarsPackagesGridContainerMobile;
